module.exports = __webpack_public_path__ + "static/media/kindergartens_gray.f00f5808.svg";